<template>
  <div>
    <div class="l-container">
      <h1 class="m-label btn">集計</h1>
      <div class="wrapper">

        <div class="list-box">
          <table-c>
            <tr-c slot="tr-th">
              <th-c style="background: #f6fdff">契約月</th-c>
              <td-c><input v-model="search.contract_month" type="text" @keyup="searchTable()" placeholder="契約月"></td-c>
            </tr-c>
          </table-c>
        </div>

        <div class="list-box">

          <div v-for="(list, index) in aggregate_contract_month.companies" :key="index">

            <h1 class="m-label m-label-custom" @click="switchColumns('columnsFlg', index)" v-bind:class="{ 'slideActive': columnsFlg[index].show }" v-ripple>{{ list.label }}</h1>

            <template v-if="columnsFlg[index].show">

              <table-c v-for="(list, index) in list.payment_types[0].offices" :key="index">
                <!-- 一括 -->
                <tr-c slot="tr-th">
                  <th-c>契約種類</th-c>
                  <td-c>一括</td-c>
                  <th-c>CXL・中途</th-c>
                  <th-c>売上金額</th-c>
                  <th-c></th-c>
                  <th-c></th-c>
                  <th-c>売掛残高</th-c>
                  <th-c></th-c>
                </tr-c>
                <tr-c slot="tr-th">
                  <th-c>営業所</th-c>
                  <td-c>{{ list.label }}</td-c>
                  <th-c>CXL 未</th-c>
                  <td-c>{{ list.columns[0].data.cxl_notpayments.toLocaleString() }}</td-c>
                  <td-c></td-c>
                  <td-c></td-c>
                  <th-c>今月</th-c>
                  <td-c>{{ list.columns[6].data.this_month.toLocaleString() }}</td-c>
                </tr-c>
                <tr-c slot="tr-th">
                  <th-c>売上金額</th-c>
                  <td-c>{{ list.columns[0].data.sum.toLocaleString() }}</td-c>
                  <th-c>CXL 済</th-c>
                  <td-c>{{ list.columns[0].data.cxl_payments.toLocaleString() }}</td-c>
                  <td-c></td-c>
                  <td-c></td-c>
                  <th-c>先月</th-c>
                  <td-c>{{ list.columns[6].data.last_month.toLocaleString() }}</td-c>
                </tr-c>
                <tr-c slot="tr-th">
                  <th-c></th-c>
                  <td-c></td-c>
                  <th-c>中途 未</th-c>
                  <td-c>{{ list.columns[0].data.cancellation_notpayments.toLocaleString() }}</td-c>
                  <td-c></td-c>
                  <td-c></td-c>
                  <th-c>先々月</th-c>
                  <td-c>{{ list.columns[6].data.before_last_month.toLocaleString() }}</td-c>
                </tr-c>
                <tr-c slot="tr-th">
                  <th-c></th-c>
                  <td-c></td-c>
                  <th-c>中途 済</th-c>
                  <td-c>{{ list.columns[0].data.cancellation_payments.toLocaleString() }}</td-c>
                  <td-c></td-c>
                  <td-c></td-c>
                  <th-c>合計</th-c>
                  <td-c>{{ list.columns[6].data.sum.toLocaleString() }}</td-c>
                </tr-c>
              </table-c>

              <table-c v-for="(list, index) in list.payment_types[1].offices" :key="index + 'B'">
                <!-- 信販 -->
                <tr-c slot="tr-th">
                  <th-c>契約種類</th-c>
                  <td-c>信販</td-c>
                  <th-c>CXL・中途</th-c>
                  <th-c>売上金額</th-c>
                  <th-c></th-c>
                  <th-c>代行手数料</th-c>
                  <th-c>売掛残高</th-c>
                  <th-c></th-c>
                </tr-c>
                <tr-c slot="tr-th">
                  <th-c>営業所</th-c>
                  <td-c>{{ list.label }}</td-c>
                  <th-c>CXL 未</th-c>
                  <td-c>{{ list.columns[0].data.cxl_notpayments.toLocaleString() }}</td-c>
                  <td-c></td-c>
                  <td-c>{{ list.columns[1].data.cxl_notpayments.toLocaleString() }}</td-c>
                  <th-c>今月</th-c>
                  <td-c>{{ list.columns[6].data.this_month.toLocaleString() }}</td-c>
                </tr-c>
                <tr-c slot="tr-th">
                  <th-c>売上金額</th-c>
                  <td-c>{{ list.columns[0].data.sum.toLocaleString() }}</td-c>
                  <th-c>CXL 済</th-c>
                  <td-c>{{ list.columns[0].data.cxl_payments.toLocaleString() }}</td-c>
                  <td-c></td-c>
                  <td-c>{{ list.columns[1].data.cxl_payments.toLocaleString() }}</td-c>
                  <th-c>先月</th-c>
                  <td-c>{{ list.columns[6].data.last_month.toLocaleString() }}</td-c>
                </tr-c>
                <tr-c slot="tr-th">
                  <th-c>代行手数料</th-c>
                  <td-c>{{ list.columns[1].data.sum.toLocaleString() }}</td-c>
                  <th-c>中途 未</th-c>
                  <td-c>{{ list.columns[0].data.cancellation_notpayments.toLocaleString() }}</td-c>
                  <td-c></td-c>
                  <td-c>{{ list.columns[1].data.cancellation_notpayments.toLocaleString() }}</td-c>
                  <th-c>先々月</th-c>
                  <td-c>{{ list.columns[6].data.before_last_month.toLocaleString() }}</td-c>
                </tr-c>
                <tr-c slot="tr-th">
                  <th-c></th-c>
                  <td-c></td-c>
                  <th-c>中途 済</th-c>
                  <td-c>{{ list.columns[0].data.cancellation_payments.toLocaleString() }}</td-c>
                  <td-c></td-c>
                  <td-c>{{ list.columns[1].data.cancellation_payments.toLocaleString() }}</td-c>
                  <th-c>合計</th-c>
                  <td-c>{{ list.columns[6].data.sum.toLocaleString() }}</td-c>
                </tr-c>
              </table-c>

              <table-c v-for="(list, index) in list.payment_types[2].offices" :key="index + 'C'">
                <!-- 自社割賦 -->
                <tr-c slot="tr-th">
                  <th-c>契約種類</th-c>
                  <td-c>自社割賦</td-c>
                  <th-c>CXL・中途</th-c>
                  <th-c>売上金額</th-c>
                  <th-c>分割手数料</th-c>
                  <th-c>代行手数料</th-c>
                  <th-c>売掛残高</th-c>
                  <th-c></th-c>
                </tr-c>
                <tr-c slot="tr-th">
                  <th-c>営業所</th-c>
                  <td-c>{{ list.label }}</td-c>
                  <th-c>CXL 未</th-c>
                  <td-c>{{ list.columns[0].data.cxl_notpayments.toLocaleString() }}</td-c>
                  <td-c>{{ list.columns[3].data.cxl_notpayments.toLocaleString() }}</td-c>
                  <td-c>{{ list.columns[2].data.cxl_notpayments.toLocaleString() }}</td-c>
                  <th-c>売上</th-c>
                  <td-c>{{ list.columns[7].data.pure_amount_all.toLocaleString() }}</td-c>
                </tr-c>
                <tr-c slot="tr-th">
                  <th-c>売上金額</th-c>
                  <td-c>{{ list.columns[0].data.sum.toLocaleString() }}</td-c>
                  <th-c>CXL 済</th-c>
                  <td-c>{{ list.columns[0].data.cxl_payments.toLocaleString() }}</td-c>
                  <td-c>{{ list.columns[3].data.cxl_payments.toLocaleString() }}</td-c>
                  <td-c>{{ list.columns[2].data.cxl_payments.toLocaleString() }}</td-c>
                  <th-c>解約 / CXL</th-c>
                  <td-c>{{ list.columns[7].data.pure_amount_cxl.toLocaleString() }}</td-c>
                </tr-c>
                <tr-c slot="tr-th">
                  <th-c>分割手数料</th-c>
                  <td-c>{{ list.columns[3].data.sum.toLocaleString() }}</td-c>
                  <th-c>中途 未</th-c>
                  <td-c>{{ list.columns[0].data.cancellation_notpayments.toLocaleString() }}</td-c>
                  <td-c>{{ list.columns[3].data.cancellation_notpayments.toLocaleString() }}</td-c>
                  <td-c>{{ list.columns[2].data.cancellation_notpayments.toLocaleString() }}</td-c>
                  <th-c>差引A</th-c>
                  <td-c>{{ list.columns[7].data.pure_amount.toLocaleString() }}</td-c>
                </tr-c>
                <tr-c slot="tr-th">
                  <th-c>お支払総額</th-c>
                  <td-c>{{ list.columns[4].data.sum.toLocaleString() }}</td-c>
                  <th-c>中途 済</th-c>
                  <td-c>{{ list.columns[0].data.cancellation_payments.toLocaleString() }}</td-c>
                  <td-c>{{ list.columns[3].data.cancellation_payments.toLocaleString() }}</td-c>
                  <td-c>{{ list.columns[2].data.cancellation_payments.toLocaleString() }}</td-c>
                  <th-c>入金額</th-c>
                  <td-c>{{ list.columns[7].data.real_amount_all.toLocaleString() }}</td-c>
                </tr-c>
                <tr-c slot="tr-th">
                  <th-c>代行手数料</th-c>
                  <td-c>{{ list.columns[2].data.sum.toLocaleString() }}</td-c>
                  <th-c></th-c>
                  <td-c></td-c>
                  <td-c></td-c>
                  <td-c></td-c>
                  <th-c>うち解約 / CXL</th-c>
                  <td-c>{{ list.columns[7].data.real_amount_cxl.toLocaleString() }}</td-c>
                </tr-c>
                <tr-c slot="tr-th">
                  <th-c></th-c>
                  <td-c></td-c>
                  <th-c>CXL 入金額</th-c>
                  <td-c>{{ list.columns[5].data.cxl.toLocaleString() }}</td-c>
                  <td-c></td-c>
                  <td-c></td-c>
                  <th-c>差引B</th-c>
                  <td-c>{{ list.columns[7].data.real_amount.toLocaleString() }}</td-c>
                </tr-c>
                <tr-c slot="tr-th">
                  <th-c></th-c>
                  <td-c></td-c>
                  <th-c>中途 入金額</th-c>
                  <td-c>{{ list.columns[5].data.cancellation.toLocaleString() }}</td-c>
                  <td-c></td-c>
                  <td-c></td-c>
                  <th-c>A - B</th-c>
                  <td-c>{{ list.columns[7].data.amount.toLocaleString() }}</td-c>
                </tr-c>
              </table-c>
            </template>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { getAPIURL } from '@/store/getters.js'
// import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/aggregate_contracts_month'
var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  // offset: config.LIMIT,
  // max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  pageName: 'aggregate_contract_month',
  pageNames: 'aggregate_contracts_month'
}
export default {
  computed: {
    aggregate_contract_month () {
      return this.$store.getters.aggregate_contract_month
    }

    // // bulkのofficeを配列に
    // jsonBulkOffices () {
    //   if (this.aggregate_contract_month.bulk) {
    //     const keys = Object.keys(this.aggregate_contract_month.bulk)
    //     const jsonBulkOffices = keys.map((key) => {
    //       return this.aggregate_contract_month.bulk[key]
    //     })
    //     return jsonBulkOffices
    //   }
    // },

    // // creditのofficeを配列に
    // jsonCreditOffices () {
    //   if (this.aggregate_contract_month.credit) {
    //     const keys = Object.keys(this.aggregate_contract_month.credit)
    //     const jsonCreditOffices = keys.map((key) => {
    //       return this.aggregate_contract_month.credit[key]
    //     })
    //     return jsonCreditOffices
    //   }
    // },

    // // own_installmentのofficeを配列に
    // jsonOwninstallmentOffices () {
    //   if (this.aggregate_contract_month.own_installment) {
    //     const keys = Object.keys(this.aggregate_contract_month.own_installment)
    //     const jsonOwninstallmentOffices = keys.map((key) => {
    //       return this.aggregate_contract_month.own_installment[key]
    //     })
    //     return jsonOwninstallmentOffices
    //   }
    // }

  },
  data () {
    return {
      columnsFlg: [
        { show: false }, // マスターマインズ
        { show: false }, // エイト
        { show: false }, // よんろく
        { show: false }, // マスターピース
        { show: false }, // マスタークライアント
        { show: false } // がくくる
      ],
      search: {
        contract_month: ''
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getAggregateContractMonth()
    })
  },
  methods: {
    switchColumns (col, index) {
      this[col][index].show = !this[col][index].show
    },

    linkContract (list) {
      console.log(list)
      // this.$router.push({name: 'contracts', params: { id: list.tutor.id }})
      this.$router.push({name: 'tutorsindex'})
    },

    searchTable (e) {
      // let that = this
      let search = this.search
      var store = this.$store
      var params = {}
      function searchTable () {
        // aggregate
        var paramsList = [
          'contract_month'
        ]
        paramsList.forEach((e) => {
          // text
          params[e] = search[e]
        })
        console.log(url)
        console.log(params)
        axios.get(obj.url, {params: params, withCredentials: true})
        .then((response) => {
        // success callback
          console.log(response)
          store.state.item.aggregate_contract_month = response.data
        }, (response) => {
        // error callback
        })
      }
      if (obj.TIMER) {
        clearTimeout(obj.TIMER)
        obj.TIMER = setTimeout(searchTable, obj.wait)
        return
      }
      obj.TIMER = setTimeout(searchTable, obj.wait)
    },

    getAggregateContractMonth () {
      this.$store.dispatch('getAggregateContractMonth')
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  .list-box {
    margin-bottom: 15px;
  }
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
  width: 10%;
}
.th {
  cursor: pointer;
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
.th {
  background: #eee !important;
}
.slideActive {
  background: #455A64;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// AggregatesContractsMonth.vue?6afc3b74